// extracted by mini-css-extract-plugin
module.exports = {"whatsapp_chat_container":"whatsapp-chat_whatsapp_chat_container__AGKXu","chat_icon":"whatsapp-chat_chat_icon__U8unS"};